import React from "react";

export default class LinkPane extends React.Component<{linkURL:string}> {

	private wrapperRef:React.RefObject<HTMLTextAreaElement>;

	constructor(props:{linkURL:string}){
		super(props);
		this.openLink=this.openLink.bind(this);
		this.copyLink=this.copyLink.bind(this);
		this.divClick=this.divClick.bind(this);
		this.wrapperRef=React.createRef();
	}

	openLink(){
		const win = window.open(this.props.linkURL, '_blank');
		if (win != null) {
			win.focus();
		}
	}

	copyLink(){
		this.wrapperRef.current?.select();
		this.wrapperRef.current?.setSelectionRange(0, 99999);
		navigator.clipboard.writeText(this.props.linkURL);
	}

	divClick(){
		this.wrapperRef.current?.select();
	}

	render() {
		return(
			<div className='teachers-linkpane'>
				<div onClick={this.divClick} className='teachers-linkpane-div'>
					<div className='teachers-linkpane-innerdiv'>
						<textarea className='teachers-linkpane-textarea' rows={1} ref={this.wrapperRef} value={this.props.linkURL} readOnly></textarea>
					</div>
				</div>
				<button onClick={this.openLink} className='teachers-button teachers-button-light'>Open</button>
				<button onClick={this.copyLink} className='teachers-button teachers-button-light'>Copy</button>
			</div>
		)
	}
}

